import { getUserNotifications, setUserNotifications } from "@/services/notifications";

const Model = {
  namespace: "notifications",
  state: {
    id: null,
    concurrencyStamp: null,
    notificationLevel: null,
    receiveDashboard: null,
    receiveEmail: null,
    receiveSms: null,
  },
  effects: {
    *fetchUserNotificationSettings({ userId }, { call, put }) {
      const response = yield call(getUserNotifications, userId);
      yield put({
        type: "set",
        payload: response,
      });

      return response;
    },
    *updateUserNotificationsSettings({ data }, { select, call }) {
      const { settingsId, concurrencyStamp } = yield select(state => {
        return {
          settingsId: state.notifications.id,
          concurrencyStamp: state.notifications.concurrencyStamp,
        };
      });

      const response = yield call(setUserNotifications, settingsId, {
        ...data,
        concurrencyStamp,
      });

      return response;
    },
  },
  reducers: {
    set(state, { payload }) {
      const { id, concurrencyStamp, notificationLevel, receiveDashboard, receiveEmail, receiveSms } = payload;

      return {
        ...state,
        id,
        concurrencyStamp,
        notificationLevel,
        receiveDashboard,
        receiveEmail,
        receiveSms,
      };
    },
  },
};

export default Model;
